import { motion, useReducedMotion } from "framer-motion";

/** The app's one easing curve. Exported so new motion matches what exists. */
export const EASE = [0.25, 0.46, 0.45, 0.94];

/**
 * PageTransition - Wrapper component for page animations.
 * Wrap page content for smooth transitions. When the user prefers reduced
 * motion, the vertical slide and durations collapse to a plain opacity fade
 * (WCAG 2.3.3 / vestibular safety — design review W1.9).
 */
function PageTransition({ children }) {
  const reduceMotion = useReducedMotion();

  const pageVariants = {
    initial: { opacity: 0, y: reduceMotion ? 0 : 20 },
    enter: {
      opacity: 1,
      y: 0,
      transition: { duration: reduceMotion ? 0 : 0.4, ease: EASE },
    },
    exit: {
      opacity: 0,
      y: reduceMotion ? 0 : -10,
      transition: { duration: reduceMotion ? 0 : 0.3, ease: EASE },
    },
  };

  return (
    <motion.div initial="initial" animate="enter" exit="exit" variants={pageVariants}>
      {children}
    </motion.div>
  );
}

export default PageTransition;
